'use client';
import Paginator from '@commons/Paginator/Paginator';
import { useEffect } from 'react';
import { useHero } from './HeroContext';
import { usePaginator } from '@commons/Paginator/PaginatorContext';

export default function HeroPaginator({ variant = 'default', children = null }) {
  const { index, items } = usePaginator();
  const { setImage } = useHero();

  useEffect(() => {
    setImage(items[index]);
  }, [index]);

  return <Paginator variant={variant}>{children}</Paginator>;
}
